import '@fontsource-variable/inter'
import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { routeTree } from './routeTree.gen'
import './styles/globals.css'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if ('status' in error && typeof error.status === 'number') {
          if (error.status === 401 || error.status === 403 || error.status === 404) return false
          return failureCount < 3
        }
        return failureCount < 3
      },
    },
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    queryClient,
  },
  defaultPreloadStaleTime: 0,
})

export type RouterContext = {
  queryClient: QueryClient
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App router={router} queryClient={queryClient} />
  </StrictMode>,
)
